// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__37vox","dragIcon":"Choice_dragIcon__2djMx","left":"Choice_left__2_kso","input":"Choice_input__2VDNo"};